<template>
  <Panel :isLoading="isLoading">
    <h2 slot="title">
      Created in the last {{ use24Hrs ? "24 hrs" : "7 days" }}
      <el-button data-testid="view-created-cases" :size="'mini'" @click="jumpToSurveillance">View More</el-button>
      <div style="display: flex; margin-left:auto;align-items:center;gap: 0.5rem">
        7 Days
        <el-switch v-model="use24Hrs" on-color="#333" off-color="#333" on-text="" off-text=""></el-switch>
        24 Hrs
      </div>
    </h2>
    <el-table :data="tableData">
      <el-table-column label="Name" prop="name"></el-table-column>
      <el-table-column label="Infection Site" prop="infectionSite"></el-table-column>
      <el-table-column label="Status" prop="status">
        <template slot-scope="scope">
          <img style="height: 42px;" :src="statusImage(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column label="Symptoms" prop="symptoms"></el-table-column>
      <el-table-column label="Location" prop="location"></el-table-column>
      <el-table-column label="Precautions" prop="precautions">
        <template slot-scope="scope">
          <template v-for="precaution in scope.row.precautions">
            <el-tag :type="precaution.isActive ? 'danger' : 'gray'">{{ precaution.name }}</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="Onset" prop="onset"></el-table-column>
    </el-table>
  </Panel>
</template>

<script>
import moment from "moment";
import Panel from "./Panel.vue";

export default {
  name: "CasesCreated",
  props: ["filters"],
  watch: {
    filters() {
      this.getCases();
    },
    use24Hrs() {
      this.getCases();
    }
  },
  components: {
    Panel
  },
  data() {
    return {
      isLoading: false,
      tableData: [],
      use24Hrs: true
    };
  },
  methods: {
    jumpToSurveillance() {
      const start = this.use24Hrs ? moment().subtract(24, "hours") : moment().subtract(7, "days");
      this.$router.push({
        path: "/surveillance",
        query: {
          ...this.$route.query,
          dashboardFilters: JSON.stringify({
            ...this.filters,
            createDateFrom: start.format(),
            createDateTo: moment().format(),
            orderBy: "onsetDate",
            outcomes: ["Not Resolved"],
            useCurrentLocation: false,
          })
        }
      });
    },
    statusImage(detail) {
      const statusImageMap = {
        GI: "bug2",
        UTI: "bug3",
        Respiratory: "bug1",
        Skin: "bug4"
      };
      var result = "";
      var filename;
      if (detail.symptomType) {
        filename = statusImageMap[detail.symptomType];
        if (!detail.status) {
          filename = filename + "s";
        }
        result = "/static/" + filename + ".png";
      }

      if (result === "") {
        filename = "bug4";
        if (!detail.status) {
          filename = filename + "s";
        }
        result = "/static/" + filename + ".png";
      }

      return result;
    },
    precautionById(id) {
      return this.$configStore.data.precautions.find(p => p.id === id).displayText;
    },
    async getCases() {
      this.isLoading = true;
      const filters = {
        ...this.filters,
        createDateFrom: moment()
          .subtract(7, "days")
          .format(),
        createDateTo: moment().format(),
        orderBy: "onsetDate",
        outcomes: ["Not Resolved"],
        useCurrentLocation: false,
        page: 1,
        size: 10
      };
      if (this.use24Hrs) {
        filters.createDateFrom = moment()
          .subtract(24, "hours")
          .format();
      }
      if (!filters.unitIds.length) {
        delete filters.unitIds;
      }
      const cases = await this.$http.post(`${window.CONFIG.infection_api}/search`, filters).then(resp => resp.json());

      this.tableData = await Promise.all(cases.content.map(async (r) => {
        const { client, onsetDate, symptoms, id } = r;
        const { firstName, lastName, middleName } = client;
        const precautionsLookup = await this.$http.get(`${window.CONFIG.precaution_api}?clientId=${client.id}&symptomDetailId=${id}`).then(resp => resp.json());
        return {
          ...r,
          precautions: precautionsLookup.content.map(({precautionId, startDate, endDate}) => ({
            name: this.precautionById(precautionId),
            isActive: !endDate || (Date.now() >= new Date(startDate) && Date.now() <= new Date(endDate))
          })),
          symptoms: symptoms.map(({ displayText }) => displayText).join(", "),
          statusImg: `${this.statusImage(r)}`,
          name: [firstName, middleName, lastName].filter(Boolean).join(' '),
          onset: moment(onsetDate).format(this.$configStore.dateFormat())
        };
      }));
      this.isLoading = false;
    }
  }
};
</script>

<style scoped></style>
